export default [
	{ value: 1, text: 'Tussenwoning' },
	{ value: 2, text: 'Hoekwoning' },
	{ value: 3, text: 'Vrijstaande woning' },
	{ value: 4, text: 'Appartement' },
	{ value: 5, text: '2-onder-1-kapwoning' },
	{ value: 6, text: 'Garagebox' },
	{ value: 7, text: 'Garage' },
	{ value: 8, text: 'Loods' },
	{ value: 9, text: 'Schuur' },
	{ value: 10, text: 'Benedenwoning' },
	{ value: 11, text: 'Bovenwoning' },
	{ value: 12, text: 'Appartementencomplex' },
	{ value: 13, text: 'Portiekflat' },
	{ value: 14, text: 'Maisonette' },
	{ value: 15, text: 'Etagewoning' },
	{ value: 16, text: 'Winkelpand' },
	{ value: 17, text: 'Industrieel object' },
	{ value: 18, text: 'Kantoorpand' },
]